import clienteAxios from "../../../config/axios";
import { FechaExacta } from "../../../config/const";

// actaEstado
// actaCiudad
// actaSector
// actaDocCliente
// actaTipo
// actaOpcion
// actaServiciosVisita
// correo_nuevo_registro
// lc_fec_reg

// autocompleteDinamico
// variante: "autocompleteDinamico",
// propiedadesMostrar: 2,
// campoData1: "perDocNumero",
// campoData2: "perNombre",
// getData: async (data) => {
//   if (data.length < 3) {
//     return;
//   }
//   const res = await clienteAxios.get(
//     `/proveedores/filtro/0?empresa=${
//       usuario.rucempresa
//     }&search=${data}&estado=${"PROVEEDOR"}&tabla=compras`
//   );
//   return res;
// },
// },

// autocompleteComun
// variante: "autocompleteComun",
// data: [
//   "APERTURA",
//   "INGRESO",
//   "EGRESO",
//   "DEPOSITO",
//   "CAJA CHICA",
//   "TRANSFERENCIA",
// ],
// autocompleteDataDefault
// variante: "autocompleteDataDefault",
// propiedadesMostrar: 1,
// campoData1: "fpagoNombre",
// getData: async () => {
// const resciudadesData = await clienteAxios.get(`/ciudades/filtro/0`);

// setciudadesData(resciudadesData.data.data);
// },
// propiedad: "venFormaPago",
export const columns = [
  {
    id: "lc_id",
    label: "Codigo",
    minWidth: 2,
    tipo: "string",
    propiedad: "lc_id",
  },
  {
    id: "lc_nombre_mascota",
    label: "Paciente",
    minWidth: 2,
    tipo: "string",
    propiedad: "lc_nombre_mascota",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "mascNombre",
    campoData2: "mascPerNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(`/mascotas/filtro/0?search=${data}`);
      return res;
    },
  },
  {
    id: "lc_id_propietario",
    label: "Propietario",
    minWidth: 150,
    tipo: "string",
    propiedad: "lc_id_propietario",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=CLIENTE`
      );
      return res;
    },
  },
  {
    id: "lc_id_medico",
    label: "Doctor",
    minWidth: 150,
    tipo: "string",
    propiedad: "lc_id_medico",
    variante: "autocompleteDinamico",
    propiedadesMostrar: 2,
    campoData1: "perDocNumero",
    campoData2: "perNombre",
    getData: async (data) => {
      const res = await clienteAxios.get(
        `/proveedores/filtro/0?search=${data}&estado=VETERINARIO`
      );
      return res;
    },
  },  
  {
    id: "lc_observacion",
    label: "Observación",
    minWidth: 2,
    tipo: "",
    propiedad: "lc_observacion",
  },
  {
    id: "lc_usuario",
    label: "User",
    minWidth: 2,
    tipo: "string",
    propiedad: "lc_usuario",
  },
  {
    id: "lc_fec_upd",
    label: "Fec Upd",
    minWidth: 50,
    tipo: "numero",
    propiedad: "lc_fec_upd",
  },
];
export const validacion = (item, setitem, seterror) => {
  const { lc_nombre_mascota, lc_nombre_medico } = item;

  if (lc_nombre_mascota.trim() === "" || lc_nombre_medico.trim() === "") {
    seterror({
      lc_nombre_mascota: lc_nombre_mascota.trim() === "",
      lc_nombre_medico: lc_nombre_medico.trim() === "",
    });
    return true;
  }
};
export const objectDefault = {
  // --- Mascota ---
  lc_id_mascota: "",
  lc_nombre_mascota: "",
  lc_raza_mascota: "",
  lc_especie_mascota: "",
  lc_sexo_mascota: "",
  lc_edad_mascota: "",

  // --- Propietario ---
  lc_id_propietario: "",
  lc_nombre_propietario: "",
  lc_email_propietario: [],

  // --- Médico ---
  lc_id_medico: "",
  lc_nombre_medico: "",

  // --- Información general ---
  lc_fecha: FechaExacta,
  lc_usuario: "",
  lc_empresa: "",
  lc_archivo: "",
  lc_eliminado: "NO",
  lc_eliminado_descripcion: "",
  lc_observacion: "",
  lc_fec_reg: "",
  lc_fec_upd: "",

  // --- Resultados de laboratorio ---
  lc_quimica_sanguinea: [],
  lc_hematologia: [],
  lc_hemostasia_coagulacion: [],
  lc_paneles_bioquimica: [],
};
